<template>
    <div>
        <div class="container">
            <div class="gr-12 gr-8@lg push-2@lg">
                <div class="wysiwyg">
                    <h2>Cookie policy</h2>

					<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iure facere eos eveniet, debitis numquam, impedit voluptatum. Accusantium repellendus, error ut? Quaerat eveniet in labore cumque perferendis sint dolore asperiores. Culpa.</p>
                    
                    <p>Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod. Maecenas faucibus mollis interdum.</p>
                    
                    <p>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor. Donec ullamcorper nulla non metus auctor fringilla. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>

                    <h4>Vestibulum ipsum</h4>
					
					<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Incidunt animi nemo necessitatibus nam placeat molestias labore laudantium dolores, distinctio cum laborum? Ex fugit aliquid itaque eius, pariatur doloremque animi maxime. Quo assumenda deserunt corporis fugit natus animi quibusdam ab voluptate aperiam est! Quaerat labore ipsam deserunt impedit asperiores porro quibusdam culpa exercitationem excepturi repellendus assumenda facere dignissimos, vitae et consectetur?</p>

					<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem porro nobis voluptate laboriosam, doloremque, quia nesciunt quaerat quis perspiciatis incidunt repudiandae optio suscipit non sed quam dolores? Numquam, explicabo, vitae.</p>
                </div>
            </div>
        </div>

        <Prefooter />
        <Footer />
        
    </div>
</template>

<script>
// components
import Prefooter from '@/components/Prefooter.vue';
import Footer from '@/components/Footer.vue'

export default {
    components: {
        Prefooter,
        Footer
    },

    data() {
        return {}
    }
};
</script>


<style scoped lang="scss">
    
</style>